import React, { useContext } from 'react';
import QuizPageWrapper from '../QuizPageWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from 'src/store';
import { Box } from '@mui/material';

import { OptionButton } from 'src/components/option-button/OptionButton';
import { updateQuizData } from 'src/store/quiz';
import { useQuizTracking } from '../../hooks';
import { submitOnboardingQuiz } from 'src/services/quiz-service';
import { ToastContext } from 'src/components/toast/toast';
import { QuizQuestionersRequest } from '../../types';
import { extractErrorMessage } from 'src/lib/utils';

const LocatedStep = () => {
  const { quizData } = useSelector((state: IAppState) => state.quiz);
  const user = useSelector((state: IAppState) => state.auth?.user);
  const dispatch = useDispatch();
  const { addToast } = useContext(ToastContext);
  const trackEvent = useQuizTracking();

  const handleClick = async (val: string) => {
    trackEvent('Country', val);
    if (
      (quizData?.isReturning || user?.status === 'INACTIVE') &&
      quizData?.FName
    ) {
      let payloadObj: QuizQuestionersRequest = {
        FName: quizData?.FName,
        LName: quizData?.LName,
        email: quizData?.email,
        goal_id: quizData.goal_id,
        target_weight: quizData?.target_weight || 0,
        problem_hitting_goal: quizData.problem_hitting_goal,
        low_intensity_days: quizData.low_intensity_days,
        high_intensity_days: quizData.high_intensity_days,
        activity_level: quizData.activity_level,
        sleep_hours: quizData.sleep_hours,
        water_intake: quizData.water_intake,
        stress_level: quizData.stress_level,
        goal_adherence_challenges: quizData.goal_adherence_challenges,
        meal_adherence_challenges: quizData.meal_adherence_challenges, // meal challenges
        weight: quizData.weight,
        interests: quizData.interests,
        located: val,
        heard_about_eq: quizData.heard_about_eq,
        // breastfeeding questions response
        is_breastfeeding: quizData.is_breastfeeding ? 1 : 0,
        breastfeeding_frequency: quizData.breastfeeding_frequency,
      };

      if (quizData?.gender) {
        payloadObj['gender'] = quizData.gender.toUpperCase(); // uppercase gender;
      }
      try {
        const submitResponse = await submitOnboardingQuiz(payloadObj);
        if (submitResponse.status === 200) {
          addToast('Updated successfully.', 'success', 5000);
          dispatch(
            updateQuizData({
              located: val,
              currentStep: 30,
            })
          );
        }
      } catch (error) {
        const message = extractErrorMessage(error);
        addToast(message, 'danger', 5000);
      }
    } else {
      dispatch(
        updateQuizData({
          located: val,
          currentStep: 29,
        })
      );
    }
  };

  return (
    <Box sx={{ marginTop: '10px' }}>
      <OptionButton
        title="Australia"
        isSelected={quizData.located === 'Australia'}
        onPress={() => handleClick('Australia')}
      />
      <OptionButton
        title="New Zealand"
        isSelected={quizData.located === 'New Zealand'}
        onPress={() => handleClick('New Zealand')}
      />
      <OptionButton
        title="United Kingdom"
        isSelected={quizData.located === 'United Kingdom'}
        onPress={() => handleClick('United Kingdom')}
      />
      <OptionButton
        title="Europe"
        isSelected={quizData.located === 'Europe'}
        onPress={() => handleClick('United Kingdom')}
      />
      <OptionButton
        title="United States"
        isSelected={quizData.located === 'United States'}
        onPress={() => handleClick('United States')}
      />
      <OptionButton
        title="Asia"
        isSelected={quizData.located === 'Asia'}
        onPress={() => handleClick('Singapore')}
      />
      <OptionButton
        title="Middle East"
        isSelected={quizData.located === 'Middle East'}
        onPress={() => handleClick('United Arab Emirates')}
      />
      <OptionButton
        title="None of the above"
        isSelected={quizData.located === 'None of the above'}
        onPress={() => handleClick('Universal')}
      />
    </Box>
  );
};

const GeneralSection = () => {
  const { quizData } = useSelector((state: IAppState) => state.quiz);

  if (quizData.currentStep === 27) {
    return (
      <QuizPageWrapper title="Where are you located?">
        <LocatedStep />
      </QuizPageWrapper>
    );
  }

  return <></>;
};
export default GeneralSection;
